import fileInput from './fileInput';
import formBuilder from './formBuilder';
import dataTable from '@/translations/fr/components/globals/dataTable';
import webSocketNotification from '@/translations/fr/components/globals/webSocketNotification';
import popUp from '@/translations/fr/components/globals/popUp';
import advancedSearch from '@/translations/fr/components/globals/advancedSearch';

export default {
	fileInput,
	formBuilder,
	dataTable,
	webSocketNotification,
	advancedSearch,
	popUp
};
